var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 219,
    viewBox: "0 0 488 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.255 0.992188H383.506C389.811 0.992188 394.929 6.11057 394.929 12.415V198.102H90.832V12.4148C90.832 6.1105 95.9503 0.992188 102.255 0.992188Z",
    fill: "white",
    stroke: "#1155CC",
    strokeWidth: 1.31989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.103 198.581V14.8906C100.103 12.3373 102.18 10.2598 104.733 10.2598H381.045C383.599 10.2598 385.676 12.3373 385.676 14.8906V198.581H100.103Z",
    fill: "white",
    stroke: "#1155CC",
    strokeWidth: 1.31989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M288.334 198.105H394.932V198.382C394.932 209.292 386.074 218.15 375.164 218.15H288.334V198.105Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 1.31989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40039 198.104H305.497V198.38C305.497 209.291 296.64 218.148 285.729 218.148H21.1689C10.2584 218.148 1.40039 209.291 1.40039 198.38V198.104Z",
    fill: "white",
    stroke: "#1155CC",
    strokeWidth: 1.31989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M339.869 83.6276L297.936 79.5586L262.179 131.45L226.491 124.127L195.258 141.615L161.151 130.156L131.627 149.786",
    stroke: "#1155CC",
    strokeWidth: 1.31989,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M339.869 95.2285L297.936 119.721L262.769 156.945L226.514 151.563L195.379 161.911L160.304 153.352L131.627 165.788",
    stroke: "#1155CC",
    strokeWidth: 1.31989,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M338.96 86.1281C340.32 86.1281 341.422 85.0256 341.422 83.6656C341.422 82.3056 340.32 81.2031 338.96 81.2031C337.6 81.2031 336.497 82.3056 336.497 83.6656C336.497 85.0256 337.6 86.1281 338.96 86.1281Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 0.659946,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M298.555 82.2902C299.915 82.2902 301.018 81.1877 301.018 79.8277C301.018 78.4677 299.915 77.3652 298.555 77.3652C297.195 77.3652 296.093 78.4677 296.093 79.8277C296.093 81.1877 297.195 82.2902 298.555 82.2902Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 0.659946,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M261.875 133.933C263.235 133.933 264.337 132.83 264.337 131.47C264.337 130.11 263.235 129.008 261.875 129.008C260.515 129.008 259.412 130.11 259.412 131.47C259.412 132.83 260.515 133.933 261.875 133.933Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 0.659946,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M195.347 143.919C196.707 143.919 197.81 142.817 197.81 141.457C197.81 140.097 196.707 138.994 195.347 138.994C193.987 138.994 192.885 140.097 192.885 141.457C192.885 142.817 193.987 143.919 195.347 143.919Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 0.659946,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M160.99 132.581C162.35 132.581 163.452 131.479 163.452 130.119C163.452 128.759 162.35 127.656 160.99 127.656C159.63 127.656 158.527 128.759 158.527 130.119C158.527 131.479 159.63 132.581 160.99 132.581Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 0.659946,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.97 152.193C132.33 152.193 133.433 151.09 133.433 149.73C133.433 148.37 132.33 147.268 130.97 147.268C129.61 147.268 128.508 148.37 128.508 149.73C128.508 151.09 129.61 152.193 130.97 152.193Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 0.659946,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M160.99 155.946C162.35 155.946 163.452 154.844 163.452 153.484C163.452 152.124 162.35 151.021 160.99 151.021C159.63 151.021 158.527 152.124 158.527 153.484C158.527 154.844 159.63 155.946 160.99 155.946Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 0.659946,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130.702 168.29C132.062 168.29 133.164 167.188 133.164 165.828C133.164 164.468 132.062 163.365 130.702 163.365C129.342 163.365 128.239 164.468 128.239 165.828C128.239 167.188 129.342 168.29 130.702 168.29Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 0.659946,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M196.422 164.327C197.782 164.327 198.885 163.225 198.885 161.865C198.885 160.505 197.782 159.402 196.422 159.402C195.062 159.402 193.96 160.505 193.96 161.865C193.96 163.225 195.062 164.327 196.422 164.327Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 0.659946,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M227.007 154.075C228.367 154.075 229.47 152.973 229.47 151.613C229.47 150.253 228.367 149.15 227.007 149.15C225.647 149.15 224.545 150.253 224.545 151.613C224.545 152.973 225.647 154.075 227.007 154.075Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 0.659946,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M227.007 126.523C228.367 126.523 229.47 125.42 229.47 124.06C229.47 122.7 228.367 121.598 227.007 121.598C225.647 121.598 224.545 122.7 224.545 124.06C224.545 125.42 225.647 126.523 227.007 126.523Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 0.659946,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M298.789 122.329C300.149 122.329 301.251 121.227 301.251 119.867C301.251 118.507 300.149 117.404 298.789 117.404C297.429 117.404 296.326 118.507 296.326 119.867C296.326 121.227 297.429 122.329 298.789 122.329Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 0.659946,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M261.875 159.403C263.235 159.403 264.337 158.301 264.337 156.941C264.337 155.581 263.235 154.479 261.875 154.479C260.515 154.479 259.412 155.581 259.412 156.941C259.412 158.301 260.515 159.403 261.875 159.403Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 0.659946,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M339.867 97.6262C341.227 97.6262 342.329 96.5237 342.329 95.1637C342.329 93.8037 341.227 92.7012 339.867 92.7012C338.507 92.7012 337.404 93.8037 337.404 95.1637C337.404 96.5237 338.507 97.6262 339.867 97.6262Z",
    fill: "#1155CC",
    stroke: "#1155CC",
    strokeWidth: 0.659946,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M324.361 149.119C355.665 149.119 381.041 123.743 381.041 92.4396C381.041 61.1362 355.665 35.7598 324.361 35.7598C293.058 35.7598 267.682 61.1362 267.682 92.4396C267.682 123.743 293.058 149.119 324.361 149.119Z",
    fill: "white",
    stroke: "#1155CC",
    strokeWidth: 11.879,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M375.038 117.812L474.317 167.526",
    stroke: "#1155CC",
    strokeWidth: 11.879,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M479.901 157.834L399.434 121.994L392.922 134.999L469.823 177.959C475.429 181.091 482.515 178.911 485.39 173.169C488.265 167.427 485.767 160.447 479.901 157.834Z",
    fill: "white",
    stroke: "#1155CC",
    strokeWidth: 1.31989,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M475.308 177.24C478.787 177.24 481.915 175.31 483.471 172.203C484.596 169.956 484.749 167.415 483.902 165.049C483.055 162.682 481.324 160.816 479.028 159.794L400.437 124.789L395.765 134.121L470.873 176.08C472.232 176.839 473.765 177.24 475.308 177.24Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M437.77 143.424L471.242 158.337L437.77 143.424ZM474.359 159.783L475.078 160.094L474.359 159.783Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M437.77 143.424L471.242 158.337M474.359 159.783L475.078 160.094",
    stroke: "#1155CC",
    strokeWidth: 1.31989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M129.112 83.7383H225.488",
    stroke: "#1155CC",
    strokeWidth: 1.31989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M129.112 99.25H216.995",
    stroke: "#1155CC",
    strokeWidth: 1.31989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M129.112 68.623H198.623",
    stroke: "#1155CC",
    strokeWidth: 1.31989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 308.806,
    y: 75.4297,
    width: 50,
    height: 6,
    transform: "rotate(45 308.806 75.4297)",
    fill: "#1155CC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 344.16,
    y: 79.6719,
    width: 50,
    height: 6,
    transform: "rotate(135 344.16 79.6719)",
    fill: "#1155CC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/noResult.3942f9b76e2828786ef5ae69e300859f.svg";
export { ForwardRef as ReactComponent };